import { Injectable } from '@angular/core';
import { Router, UrlSegment } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { urls } from 'src/app/constants/externalUrlsConstants';
import { SharedService } from 'src/app/layouts/shared-service';
import { GroupsService } from 'src/app/services/groups.service';
import { PermissionsService } from 'src/app/services/security/permissions.service';

@Injectable({
    providedIn: 'root',
})
export class FboBusinessService {
    constructor(private router: Router,
        private sharedService: SharedService,
        private groupsService: GroupsService,
        private permissions: PermissionsService
    ) { }
    public async logIntoFboAccount(fbo: any, isNetworkFbo: boolean, isConductorUser: boolean): Promise<void> {
        const isSingleSourceFboResponse = this.groupsService.isGroupFboSingleSource(fbo.icao);
        let isSingleSourceFbo = await lastValueFrom(isSingleSourceFboResponse);
        const role = this.sharedService.currentUser.role;

        //let hostName = window.location.hostname;
        //let href = window.location.href;

        ////remove this when environment variable configuration is on on deployment
        //if (hostName === 'support.fbolinx.com') {
        //    href = href.replace(hostName, "www.fbolinx.com");
        //}
        //else if (hostName === 'support-qa-app.fbolinx.com') {
        //    href = href.replace(hostName, "qa-app.fbolinx.com");
        //}
        ////href = href.replace(hostName, environment.hostNames.base);

        //href = href.replace(
        //    window.location.pathname,
        //    urls.outsideGatePath +
        //        this.sharedService.currentUser.authToken
        //);
        
        this.permissions.setIsFboSelected(true);

        let href = urls.outsideGatePath + this.sharedService.currentUser.authToken;
        if (isConductorUser)
            href = this.sharedService.supportUrl + '/' + href;
        else
            href = this.sharedService.memberUrl + '/' + href;

        const newUrl = `${href}&groupId=${fbo.groupId}&fboId=${fbo.oid}&accountType=${fbo.accountType}&icao=${fbo.icao}&isSingleSourceFbo=${isSingleSourceFbo}&isNetworkFbo=${isNetworkFbo}&role=${role}`;
        if (window.location.href !== newUrl) {
            this.router.navigate([]).then((result) => {
                window.open(newUrl, '_blank');
            });
        }
    }
}
